import {
  Component,
  ElementRef,
  inject,
  input,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { StoryblokDirective } from '../../../directives/storyblok.directive';
import { RdsButtonModule, RdsIconsModule } from '@rds/angular-components';
import { Components } from '../../../components';
import { DynamicModule } from 'ng-dynamic-component';

@Component({
  selector: 'inexp-featured',
  imports: [StoryblokDirective, DynamicModule, RdsButtonModule, RdsIconsModule],
  templateUrl: './featured.component.html',
  styleUrl: './featured.component.scss',
})
export class FeaturedComponent {
  _editable = input<string>();
  _uid = input<string>();
  component = input<string>();

  content = input<any[]>([]);
  title = input<string>();
  subtitle = input<string>();
  iconLeft = input<string>();
  iconRight = input<string>();

  components = Components;

  @ViewChild('carousel', { static: false }) carousel!: ElementRef;
  @ViewChild('carouselContainer', { static: false })
  carouselContainer!: ElementRef;

  private isDragging = false;
  private startX = 0;
  private scrollLeft = 0;
  private readonly _renderer = inject(Renderer2);

  onDragStart(event: MouseEvent) {
    this.isDragging = true;
    this.startX = event.pageX - this.carousel.nativeElement.offsetLeft;
    this.scrollLeft = this.carousel.nativeElement.scrollLeft;
    this._renderer.setStyle(this.carousel.nativeElement, 'cursor', 'grabbing');
  }

  onDragMove(event: MouseEvent) {
    if (!this.isDragging) return;
    event.preventDefault();
    const x = event.pageX - this.carousel.nativeElement.offsetLeft;
    const walk = x - this.startX;
    this.carousel.nativeElement.scrollLeft = this.scrollLeft - walk;
  }

  onDragEnd() {
    this.isDragging = false;
    this._renderer.setStyle(this.carousel.nativeElement, 'cursor', 'grab');
  }

  scrollToLeft() {
    this.carousel.nativeElement.scrollBy({
      left: -this.carouselContainer.nativeElement.clientWidth,
      behavior: 'smooth',
    });
  }

  scrollToRight() {
    this.carousel.nativeElement.scrollBy({
      left: this.carouselContainer.nativeElement.clientWidth,
      behavior: 'smooth',
    });
  }
}
